export default __webpack_public_path__ + "static/media/mountain-2.1ca86197.png";